var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              ref: "detailForm",
              attrs: {
                model: _vm.detail,
                rules: _vm.rules,
                "label-width": "100px",
                "label-position": _vm.device === "mobile" ? "top" : "right",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 23 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "标题", prop: "title" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入文章标题",
                              clearable: "",
                            },
                            model: {
                              value: _vm.detail.title,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.detail,
                                  "title",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "detail.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, md: 11 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "分类", prop: "articleType" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择文章分类",
                                clearable: "",
                              },
                              model: {
                                value: _vm.detail.articleType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detail, "articleType", $$v)
                                },
                                expression: "detail.articleType",
                              },
                            },
                            _vm._l(_vm.articleType, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, md: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "状态", prop: "status" },
                        },
                        [
                          _c("el-switch", {
                            staticClass: "rectangle",
                            attrs: {
                              width: 60,
                              "active-color": "#13ce66",
                              "active-value": 1,
                              "inactive-value": 0,
                            },
                            model: {
                              value: _vm.detail.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "status", $$v)
                              },
                              expression: "detail.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, md: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "弹窗显示", prop: "isPopup" },
                        },
                        [
                          _c("el-switch", {
                            staticClass: "rectangle",
                            attrs: {
                              width: 60,
                              "active-color": "#13ce66",
                              "active-value": 1,
                              "inactive-value": 0,
                            },
                            model: {
                              value: _vm.detail.isPopup,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "isPopup", $$v)
                              },
                              expression: "detail.isPopup",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 23 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "内容摘要", prop: "summary" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: "",
                              placeholder: "请输入内容摘要",
                            },
                            model: {
                              value: _vm.detail.summary,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.detail,
                                  "summary",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "detail.summary",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 23 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "文章内容", prop: "planText" } },
                        [
                          _c("my-editor", {
                            attrs: {
                              text: _vm.detail.planText,
                              images: _vm.editorImages,
                              "not-exists": _vm.deletedImages,
                              "auto-focus": false,
                            },
                            on: {
                              "update:text": function ($event) {
                                return _vm.$set(_vm.detail, "planText", $event)
                              },
                              "update:images": function ($event) {
                                _vm.editorImages = $event
                              },
                              "update:notExists": function ($event) {
                                _vm.deletedImages = $event
                              },
                              "update:not-exists": function ($event) {
                                _vm.deletedImages = $event
                              },
                              change: _vm.editorChange,
                            },
                            model: {
                              value: _vm.detail.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "content", $$v)
                              },
                              expression: "detail.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-form-button-group" },
        [
          _c(
            "el-button",
            { attrs: { icon: "el-icon-back" }, on: { click: _vm.onBack } },
            [_vm._v("返回列表")]
          ),
          _c(
            "el-button",
            { attrs: { type: "info" }, on: { click: _vm.onCreateArticle } },
            [_vm._v("新增文章")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
            [_vm._v("提交保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }